import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { TemplateActions } from './template.actions';

@Injectable({ providedIn: 'root' })
export class TemplateActionsFacade {
  private readonly _store = inject(Store);

  public loadTemplates(hasImpersonatedBuyer: boolean, companyId: number): void {
    this._store.dispatch(
      TemplateActions.loadTemplates({ hasImpersonatedBuyer, companyId }),
    );
  }

  public createTemplateFolder(name: string, parentFolderId?: number): void {
    this._store.dispatch(
      TemplateActions.createTemplateFolder({ name, parentFolderId }),
    );
  }

  public resetCreationState(): void {
    this._store.dispatch(TemplateActions.reset());
  }
}
